module.exports = __webpack_public_path__ + "img/kari1.e3df3d36.png";